import { host_haiji_url } from '@/api/host'
var exportApi = {
  //导出用户列表
  getExportListUrl:`${host_haiji_url}/v1/admin/export`,//获取用户列表导出 http://projectdoc.epetbar.com/web/#/177?page_id=4614
  getOssUrl:`${host_haiji_url}/v1/admin/oss/url`,//获取oss验签url http://projectdoc.epetbar.com/web/#/177?page_id=4115
}

export { exportApi }